/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, memo } from 'react'
import { ListSubheader, MenuOption, Typography } from '@maas-components/core'
import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import { convertPackageValues } from 'core/common/utils/formikHelpers'
import TextField from 'core/components/TextField'
import { TFreights, TGroupValues } from 'core/services/models/freight'
import { ProductFreightV2Values } from '../constants'

interface FreightSelectProps {
  freights: TFreights[]
  value?: string
  formikValidations?: any
  onSelect: (selectedOption: string, index: number) => void
  index: number
}

const FreightSelect: React.FC<FreightSelectProps> = ({
  freights,
  value,
  onSelect,
  formikValidations,
  index,
}) => {
  const { values, setValues } = useFormikContext<ProductFreightV2Values>()

  // Campos que representam "size"
  const sizeFields = ['depth', 'height', 'width']

  const setPackageValues = (selectedPackage: string) => {
    const selectedFreight = freights
      .reduce((prev, curr) => [...prev, ...curr.values], [] as TGroupValues[])
      .find(findableFreight => findableFreight.id === Number(selectedPackage))

    if (!selectedFreight) return

    setValues({
      ...values,
      variations: values.variations.map((variation, i) =>
        i === index
          ? {
              ...variation,
              package: {
                ...variation.package,
                ...convertPackageValues(selectedFreight, selectedPackage, 'cm'),
              },
            }
          : variation
      ),
    })
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setPackageValues(value)
    onSelect(value, index)
  }

  const formikValidationErrors = formikValidations?.formikProps.errors

  const packageErrors =
    formikValidationErrors?.variations?.[index]?.package || formikValidationErrors?.package || {}

  const errorMessages =
    sizeFields
      .map(field => packageErrors[field])
      .filter(Boolean)
      .join(', ') || ''

  return (
    <TextField
      label={i18n.t('productNew.logistic.labelStandardDimensions')}
      name={`variations.${index}.package.size`}
      value={value}
      onChange={handleChange}
      hiddenLabel
      fullWidth
      select
      style={{ backgroundColor: '#fff' }}
      error={Boolean(errorMessages)}
      helperText={errorMessages}
    >
      {freights?.map(group => [
        <ListSubheader component="a">
          <Typography component="span">{group.label}</Typography>
        </ListSubheader>,
        group.values.map(({ id, width, height, depth, label }) => (
          <MenuOption key={id} value={id}>
            {`${label} ${width / 10} x ${height / 10} x ${depth / 10} cm`}
          </MenuOption>
        )),
      ])}
    </TextField>
  )
}

export default memo(FreightSelect)
